document.addEventListener("DOMContentLoaded", function() {
    const pageLang = document.documentElement.lang; // Get the language from <html lang="">

    if (pageLang === "en") { // Check if the page language is English
        // Function to search and replace text
        function replaceTextInNode(node) {
            if (node.nodeType === Node.TEXT_NODE) { // If it's a text node
                node.textContent = node.textContent.replace(/Brigage ORAKI/g, "ORAKI Brigade");
            } else { // Otherwise, recursively check child nodes
                node.childNodes.forEach(replaceTextInNode);
            }
        }

        // Function to initiate text replacement across the document body
        function replaceTextOnPage() {
            replaceTextInNode(document.body);
        }

        // Create a MutationObserver to detect Smile.io content
        const observer = new MutationObserver((mutationsList, observer) => {
            // Loop through each mutation detected
            for (let mutation of mutationsList) {
                if (mutation.type === "childList") {
                    // Check for a unique Smile.io element to know it's loaded
                    if (document.querySelector(".smile-io-widget")) {
                        // Once detected, replace text and disconnect observer
                        replaceTextOnPage();
                        observer.disconnect();
                        break;
                    }
                }
            }
        });

        // Start observing the body for added child elements
        observer.observe(document.body, { childList: true, subtree: true });
    }
});
